import React, {createRef, useState, useContext} from 'react';
import SystemContext from "../../../SystemContext";
import { Grid } from "@material-ui/core";
import FlightIcon from "@material-ui/icons/Flight";
import { AgentWarehouse, GhaWarehouse, ControlTower, Progress } from '../../../controls/TrackAndTraceImages';

const StatusBlock = (_props) => {

  const props = {
    blockCount: 1,
    status:  "Awaiting",
    ..._props
  }

  let bgColor = "#d0d0d0";
  let statusColor = "#808080";
  switch (props.status) {
    case 'Delivered':
    case 'Departed':
      statusColor = '#84D491';
      break;
    case 'Booked':
      statusColor = '#FF5C00';
      break;
    case 'Received':
      statusColor = '#FF5C00';
      break;
    default:
      statusColor = "#808080";
  }

  let height = 100*(props.blockCount||1)+(5*((props.blockCount||1)-1));

  return (
    <>  
      <div style={{position: "relative", background: bgColor, minHeight: height}}>
        <div style={{position: "relative", width: "100%", top: 5, height: 20, fontSize: 13}}>{props.pieces} Pieces</div>
        <div style={{position: "relative", width: "100%", top: 5, height: 20, fontSize: 13}}>{props.weight}kg</div>
        <div style={{position: "absolute", width: "100%", bottom: 10, height: 20, fontWeight:"bold", fontSize: 13}}>{props.status}</div>
        <div style={{position: "absolute", width: "100%", bottom: 0, height: 10, backgroundColor: statusColor}}></div>
      </div>
      <div style={{minHeight: 5}}>
      </div>
    </>
  )
}

const ShipmentTrackingRouteMap = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const classes = props.classes;
  const [record, setRecord] = useState(props.record);

  const routeData = [
    {date: '10th Aug', events: [
      {type: 'Delivered', pieces: 200, weight: 440, blocks: 1}
    ]},
    {date: '11th Aug', events: [
      {type: 'Departed', pieces: 100, weight: 240, blocks: 1},
      {type: 'Booked', pieces: 100, weight: 240, blocks: 1}
    ]},
    {date: '11th Aug', events: [
      {type: 'Received', pieces: 100, weight: 240, blocks: 1},
      {type: 'Awaiting', pieces: 100, weight: 200, blocks: 1}
    ]},
    {date: '12th Aug', events: [
      {type: 'Awaiting', pieces: 200, weight: 440, blocks: 2}
    ]},
    {date: '12th Aug', events: [
      {type: 'Awaiting', pieces: 200, weight: 440, blocks: 2}
    ]},
    {date: '12th Aug', events: [
      {type: 'Awaiting', pieces: 200, weight: 440, blocks: 2}
    ]},
    {date: '12th Aug', events: [
      {type: 'Awaiting', pieces: 200, weight: 440, blocks: 2}
    ]},
    {date: '12th Aug', events: [
      {type: 'Awaiting', pieces: 200, weight: 440, blocks: 2}
    ]},
    {date: '12th Aug'},
    {date: '12th Aug'},
    {date: '12th Aug'}
  ]

  const flights = [
    [
      {date: '10th Aug', pieces: 200, weight: 440, blocks: 1, percentage: 100}
    ],
    [
      {flightNo: 'CC332', date: '11th Aug', pieces: 100, weight: 240, blocks: 1, percentage: 100},
      {flightNo: 'CC432', date: '12th Aug', pieces: 100, weight: 200, blocks: 1, percentage: 30},
    ],
    [
      {flightNo: 'CC452', date: '12th Aug', pieces: 200, weight: 440, blocks: 2, percentage: 0},
    ],
    [
      {date: '12th Aug', pieces: 200, weight: 440, blocks: 2, percentage: 0}
    ],
    [
      {date: '12th Aug', pieces: 200, weight: 440, blocks: 2, percentage: 0}
    ],
    [
      {date: '12th Aug', pieces: 200, weight: 440, blocks: 2, percentage: 0}
    ],
    [
      {date: '12th Aug', pieces: 200, weight: 440, blocks: 2, percentage: 0}
    ],
    [
      {date: '12th Aug', pieces: 200, weight: 440, blocks: 2, percentage: 0}
    ],
    [
      {date: '12th Aug', pieces: 200, weight: 440, blocks: 2, percentage: 0}
    ],
    [
      {date: '12th Aug', pieces: 200, weight: 440, blocks: 2, percentage: 0}
    ],
  ]

  if ((props.record && !record) || (!props.record && record) || (props.record && record && props.record.awbNo !== record.awbNo) ) {
    setRecord(props.record);
  }
  console.log(`ROUTE`, JSON.stringify(_props.route));

  const SystemData = useContext(SystemContext);

  return (
    <div key="awbContainer" style={{ textAlign:"left", backgroundColor: "#ffffff", padding: 10, color: "#404040"}}>
      {record && props.route?
        <div style={{display: "inline-flex", width: "calc(100vw - 100px)"}}>
          <div style={{display: "inline-flex"}}>
            <div style={{display: "table", width: 70, minWidth: 70, textAlign: "center"}}>
              <div style={{display: "block", height: 50}}>
                <AgentWarehouse/>
              </div>
              <div style={{display: "block", height: 46, maxHeight: 46}}>
                Agent / Shipper
              </div>
              {(routeData[0].events||[]).map((event, e) => (
                <StatusBlock blockCount={event.blocks} status={event.type} pieces={event.pieces} weight={event.weight}/>  
              ))}
            </div>
          </div>
          <div style={{display: "inline-flex", width: 150, minWidth: 150, padding: "0px 20px"}}>
            <div style={{display: "table", textAlign: "center"}}>
              <div style={{display: "block", height: 50}}>
              </div>
              <div style={{display: "block", height: 46, maxHeight: 46}}>
              </div>
              <div style={{minHeight: 80, maxHeight: 80}}>
                 <div style={{marginTop: 25, minHeight: 50}}>{routeData[0].date}</div>
                 <Progress percentage={flights[0][0].percentage}/>
              </div>
            </div>
          </div>
          { props.route.map((airport, i) => (
          <>  
            {i > 0? 
            <div style={{display: "inline-flex", width: `calc(${Math.round((100/(props.route.length - 1)))}% - 380px)`, padding: "0px 20px"}}>
              <div style={{display: "table", textAlign: "center", width: "100%"}}>
              <div style={{display: "block", height: 50}}></div>
              <div style={{display: "block", height: 46, maxHeight: 46}}></div>
              {flights[i].map((flight, f) => (
                <>
                <div>
                  <div style={{minHeight: 80*(flight.blocks||1)+(5*((flight.blocks||1)-1)), maxHeight: 80*(flight.blocks||1)+(5*((flight.blocks||1)-1))}}>
                    {flight.blocks > 1 ? (
                      <div style={{minHeight: 105 * (flight.blocks - 1)}}></div>
                    ): <></>}
                    <div style={{marginTop: 25, minHeight: 50}}>{flight.date}</div>
                    <Progress percentage={flight.percentage}/>
                  </div>
                </div>
                <div style={{heigth: 5}}></div>
                </>
              ))}
              </div>
            </div>
            : <></>}
            <div style={{display: "inline-flex"}}>
              <div style={{display: "table", width: 110, minWidth: 110, textAlign: "center"}}>
                <div style={{display: "block", height: 50}}>
                  <GhaWarehouse/>
                </div>
                <div style={{display: "block", height: 46, maxHeight: 46}}>
                  {airport.airportCode}
                </div>
                {(routeData[i+1].events||[]).map((event, e) => (
                  <StatusBlock blockCount={event.blocks} status={event.type} pieces={event.pieces} weight={event.weight}/>  
                ))}
              </div>
            </div>
          </>
          ))}
          <div style={{display: "inline-flex", width: 150, minWidth: 150, padding: "0px 20px"}}>
            <div style={{display: "table", textAlign: "center"}}>
              <div style={{display: "block", height: 50}}>
              </div>
              <div style={{display: "block", height: 46, maxHeight: 46}}>
              </div>
              {flights[props.route.length].map((flight, f) => (
                <>
                <div>
                  <div style={{minHeight: 80*(flight.blocks||1)+(5*((flight.blocks||1)-1)), maxHeight: 80*(flight.blocks||1)+(5*((flight.blocks||1)-1))}}>
                    {flight.blocks > 1 ? (
                      <div style={{minHeight: 105 * (flight.blocks - 1)}}></div>
                    ): <></>}
                    <div style={{marginTop: 25, minHeight: 50}}>{flight.date}</div>
                    <Progress percentage={flight.percentage}/>
                  </div>
                </div>
                <div style={{heigth: 5}}></div>
                </>
              ))}
            </div>
          </div>
          <div style={{display: "inline-flex"}}>
            <div style={{display: "table", width: 70, minWidth: 70, textAlign: "center"}}>
              <div style={{display: "block", height: 50}}>
                <AgentWarehouse/>
              </div>
              <div style={{display: "block", height: 46, maxHeight: 46}}>
                Agent / Shipper
              </div>
              {(routeData[props.route.length].events||[]).map((event, e) => (
                <StatusBlock blockCount={event.blocks} status={event.type} pieces={event.pieces} weight={event.weight}/>  
              ))}
            </div>
          </div>
        </div>
      :<></>
    }
    </div>
  );
}

export default ShipmentTrackingRouteMap;
